module.exports = __webpack_public_path__ + "img/hr-sand-rock-small-14.a3255b52.png";